




import { Component, Vue } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'
import MypageTopDownloadHistory from '../../components/Membership/Mypage/MypageTopDownloadHistory.vue'

@Component({
  components: { MypageTopDownloadHistory }
})
export default class Mypagetop extends Vue {
  // MypageTopDownloadHistoryのダミーページ
  // コンポーネント化した部品をページに生成しないと、非ログイン時にcreatedイベントが実施されるため

  // --------------------------------------------------------------------------------------------------------------------
  // Props
  get isLogin(): boolean {
    return membershipState.isLogin
  }
}
